import { Component, ViewModel, View } from "binder";
import { getAsBoolean } from "../utilities";
import  { DragDropContainerView } from "./dragDropContainer-view"

export class DragDropContainerViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.internalForViewModel = parentViewModel;
    }
    GetDefaultView(): View <ViewModel> {
        return new DragDropContainerView();
    }
    public getTypeId(): string {
        return "VM-33FB8725-0DF2-447D-B894-7AC894DEF7B6"
    }
    public set dragable(v: boolean) { this._dragable = getAsBoolean(v); } public get dragable(): boolean { return this._dragable;} private _dragable: boolean;
    public set allowdropinto(v: boolean) { this._allowdropinto = v; } public get allowdropinto(): boolean { return this._allowdropinto;} private _allowdropinto: boolean;
    public set internalForViewModel(v: ViewModel) { this._internalForViewModel = v; } public get internalForViewModel(): ViewModel { return this._internalForViewModel;} private _internalForViewModel: ViewModel;
    
}
